import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { Observable } from 'rxjs/Rx';
import * as $ from 'jquery';

import { Faculty, Queue } from '../../models';
import { FacultyService } from '../../services';
import { AlertUtils, ParamUtils } from '../../shared';
import { FACULTY_LIST_MODIFICATION } from '../../shared/constants';

@Component({
    selector: 'qms-faculty-queues',
    templateUrl: './faculty-queues.component.html',
    styleUrls: ['./faculty-queues.component.css']
})
export class FacultyQueuesComponent implements OnInit, AfterViewChecked {

    public facultyId: number;
    public faculty: Faculty;
    public faculties: Observable<Array<Faculty>>;
    public queues: Observable<Array<Queue>>;

    private subscription: Subscription;
    private eventSubscription: Subscription;

    constructor(private eventManager: JhiEventManager,
                private facultyService: FacultyService,
                private alertService: JhiAlertService,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            ParamUtils.parseNumber(params['id'], (facultyId: number) => {
                this.facultyId = facultyId;
                this.load(this.facultyId);
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
            });
        });
        this.registerChangeInFaculties();
    }

    public refresh() {
        this.queues = this.facultyService.findQueuesPublic(this.faculty.id);
    }

    private load(id) {
        this.facultyService.find(id).subscribe((faculty: Faculty) => {
            this.faculty = faculty;
        });

        this.faculties = this.facultyService.all();
        this.queues = this.facultyService.findQueuesPublic(id);
    }

    private registerChangeInFaculties() {
        this.eventSubscription = this.eventManager.subscribe(
            FACULTY_LIST_MODIFICATION,
            (response) => this.load(this.faculty.id)
        );
    }

    ngAfterViewChecked() {
        this.resizeNames();
    }

    private resizeNames() {
        let maxHeight = 0;
        const box = $('div.name.tile');
        box.each(function() {
            maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight);
        });
        box.height(maxHeight);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/faculty-queues/faculty-queues.component.ts